import FormattedMessage from 'I18n/components/FormattedMessage';
import ButtonWithEditWarning from './ButtonWithEditWarning';
import { UploadIcon } from 'foundations-assets/icons/components/UploadIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const LocalFileButton = ({
  onClick,
  editWarningConfig
}) => {
  return /*#__PURE__*/_jsx(ButtonWithEditWarning, Object.assign({}, editWarningConfig, {
    onClick: onClick,
    icon: UploadIcon,
    disabled: false,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "headerButtons.createPanel.buttons.localFile"
    })
  }));
};
export default LocalFileButton;